import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId } from "react";
import * as styles from "./Dialog.css.js";
import { CloseXIcon } from "../icons.js";
// A modal dialog (role="dialog", aria-modal). Closes on Esc or overlay click. Rendered
// inline (no portal) so it's trivially testable; the app shell decides mount point.
export const Dialog = ({ open, onClose, title, subtitle, compact = false, children, footer, }) => {
    const titleId = useId();
    useEffect(() => {
        if (!open)
            return;
        const onKey = (e) => {
            if (e.key === "Escape")
                onClose();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);
    if (!open)
        return null;
    return (_jsx("div", { className: styles.overlay, onClick: onClose, children: _jsxs("div", { className: styles.panel[compact ? "compact" : "default"], role: "dialog", "aria-modal": "true", "aria-labelledby": titleId, onClick: (e) => e.stopPropagation(), children: [_jsxs("div", { className: styles.header, children: [_jsxs("div", { className: styles.titleGroup, children: [_jsx("h2", { id: titleId, className: styles.title, children: title }), subtitle !== undefined && (_jsx("p", { className: styles.subtitle, children: subtitle }))] }), _jsx("button", { type: "button", className: styles.closeButton, "aria-label": "Close", onClick: onClose, children: _jsx(CloseXIcon, {}) })] }), _jsx("div", { className: styles.body, children: children }), footer !== undefined && _jsx("div", { className: styles.footer, children: footer })] }) }));
};
//# sourceMappingURL=Dialog.js.map